import { Accordion, AccordionItem } from "components/shared/accordion/accordion";
import { OptionGallery } from "components/shared/gallery/option_gallery";
import PillMenu from "components/shared/pill-menu/pill-menu";
import Modal from "components/shared/modal/modal";
import { useEffect, useRef, useState } from "react";


export default function ProductSpecificationModal(props) {
    let optionList = [];
    const [modalState, setModalState] = useState(-1);
    const [specificationModalDataState, setSpecificationModalDataState] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [expandIndexState, setExpandIndexState] = useState(-1);
    const [compactView, setCompactView] = useState(false);
    const childRef = useRef(null);
    
    useEffect(() => {
        if (expandIndexState != -1) {
            document.getElementsByClassName('product-specification-modal')[0].scrollTo(
                {
                    top: document.getElementById('accordion-item-' + expandIndexState).offsetTop - 100
                }
            );
        }
    },[expandIndexState]);

    useEffect(() => {
        handleResize();
    },[]);

    useEffect(() => {
        setSpecificationModalDataState(getSpecificationData(props, modalState));
        setFilteredOptions(getFilteredOptions(props, modalState));
    },[modalState]);

    showSpecModal = (materialId) => {
        childRef.current.showModal(materialId === -1 ? false : true);
        setModalState(materialId);
    }
    
    function handleResize () {
        if (window.matchMedia("(max-width: 1000px)").matches) {
            setCompactView(true);
        } else {
            setCompactView(false);
        }
    }
    

    function onPillClick(e) {
        setExpandIndexState(parseInt(e.target.dataset.index));
    }

    window.addEventListener("resize", handleResize);

    window.showSpecModal = showSpecModal;

    const [modalImage, setModalImage] = useState(null);

    useEffect(() => {
        if (!modalImage) return;
        const onKey = (e) => e.key === 'Escape' && setModalImage(null);
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [modalImage]);

    const openImageModal = (e, option) => {
        e.stopPropagation();
        const sizes = option?.image?.sizes || {};
        const fullSrc =
            sizes.large || sizes.full || option?.image?.url || sizes.medium;
        setModalImage({ src: fullSrc, alt: option?.title });
    };

    const closeModal = (e) => {
        if (e) e.stopPropagation();
        setModalImage(null);
    };
    

    let output = (
        <Modal ref={childRef} {...props}>
            <div className='top-bar'>
                <div className='top-menu'>
                    <div className='menu'>
                        <h3 style={{margin: 'auto 1rem', padding: '.25rem 0'}}>{ props.materialSpecifications[modalState === -1 ? 0 : modalState].material.label} Specifications</h3>
                    </div>
                    <div id='close' style={{padding: '1rem'}} onClick={() => {showSpecModal(-1)}}>X</div>
                </div>
                <div className='sub-menu'>
                    <PillMenu items={filteredOptions} onPillClick={onPillClick}></PillMenu>
                </div>
            </div>
            <div className='product-specification-modal'>
                <Accordion setExpandIndexState={setExpandIndexState} visibleOnCollapse={true} stickyHeader={true} activeIndexState={expandIndexState}>
                    {
                        filteredOptions ? filteredOptions.map(function(option, i){
                            if (!option.option.length) {
                                return <></>;
                            }

                            let alwaysVisibleOptionsNum = compactView ? 3 : 4;

                            let remainingResultsOffset = compactView ? -1 : 0;
                            if (option.option_name === "Mounting Options") {
                                alwaysVisibleOptionsNum = 1;
                                remainingResultsOffset = 0;
                            }

                            return (
                                <AccordionItem 
                                    title={option.option_name}
                                    index={i}
                                    showMore={true}
                                    alwaysVisibleOptionsNum={alwaysVisibleOptionsNum}
                                    numOfOptions={option.option.length}>
                                    <OptionGallery
                                        title={option.option_name}
                                        expand={expandIndexState === i}
                                        option={option.option}
                                        index={i}
                                        material={props.materialSpecifications[modalState === -1 ? 0 : modalState].material}
                                        showMore={true}
                                        direction={option.option_name === "Mounting Options" ? 'column' : 'row'}
                                        openImageModal={openImageModal}
                                        closeModal={closeModal}
                                        modalImage={modalImage}></OptionGallery>
                                </AccordionItem>
                            )
                        }) : ''
                    }
                </Accordion>
            </div>
        </Modal>
    );
    return output;
}

function getSpecificationData(props, modalState) {
    return props.materialSpecifications[modalState === -1 ? 0 : modalState].modal_specifications || [];
}

function getFilteredOptions(props, modalState) {
    let tempOptions = structuredClone(props.options);

    for (var i=0; props.options.length > i; i++) {
        if (!props.options[i].option) {
            continue;
        }
        tempOptions[i].option = props.options[i].option.filter((value) => {
            if (value.material.includes(props.materialSpecifications[modalState === -1 ? 0 : modalState].material.value)) {
                return value;
            }
        });
    }

    return tempOptions;
}
